const e = "styles-module__header_container___bmwWl", _ = "styles-module__header___qfWjE", t = "styles-module__header_content___P65di", s = "styles-module__sub_title___Isu-M", l = "styles-module__title___iw2Ch", o = "styles-module__back___7B9DE", n = "styles-module__header_container_fullscreen___k7cGT", a = "styles-module__rooms_available_fullscreen___K2-E6", u = "styles-module__subtitle___JVVNk", c = "styles-module__subtitle_with_back___bzudb", r = "styles-module__subtitle_fullscreen___ihp7w", d = "styles-module__icon___U-a7l", i = "styles-module__dates___z4rat", b = "styles-module__guests___wd9d1", m = "styles-module__header_submit_container___W8P69", h = "styles-module__header_cart_button___o-RwB", y = "styles-module__header_submit___AGvMA", f = {
  header_container: e,
  header: _,
  header_content: t,
  sub_title: s,
  title: l,
  back: o,
  header_container_fullscreen: n,
  rooms_available_fullscreen: a,
  subtitle: u,
  subtitle_with_back: c,
  subtitle_fullscreen: r,
  icon: d,
  dates: i,
  guests: b,
  header_submit_container: m,
  header_cart_button: h,
  header_submit: y
};
export {
  o as back,
  i as dates,
  f as default,
  b as guests,
  _ as header,
  h as header_cart_button,
  e as header_container,
  n as header_container_fullscreen,
  t as header_content,
  y as header_submit,
  m as header_submit_container,
  d as icon,
  a as rooms_available_fullscreen,
  s as sub_title,
  u as subtitle,
  r as subtitle_fullscreen,
  c as subtitle_with_back,
  l as title
};
